import { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import useDeepLinkContext from './useDeepLinkContext';
import * as StampCardService from '../api/stampCardService';
import * as CouponService from '../api/couponService';
import * as StoreService from '../api/storeService';

export default function useDeepLinkHandler() {
  const dl = useDeepLinkContext();
  const history = useHistory();

  const handleSingleUseCode = useCallback(
    async (
      singleUseCode: string,
      merchantId: string,
      stampNum: string,
      storeId: string,
    ) => {
      console.log('SingleUseCode: ', singleUseCode);
      console.log('storeId: ', storeId);
      console.log('stampNum: ', stampNum);
      console.log('merchantId: ', merchantId);
      if (singleUseCode && storeId && stampNum && merchantId) {
        console.log('Redeeming single use code...');
        try {
          const resRedeem = await StampCardService.creditStampCardSingleUse(
            singleUseCode,
            storeId,
            parseInt(stampNum),
            merchantId,
          );
          if (resRedeem && resRedeem.id) {
            history.replace(
              `/merchant/${merchantId}/stampNum/${stampNum}/stampCard/${resRedeem.id}/singleUseRedeem/status/success/msg/ok`,
            );
            history.go(0);
          }
        } catch (e: any) {
          console.log('ResRedeem Error: ', e);
          if (e && typeof e === 'object') {
            console.log(JSON.stringify(e));
            history.replace(
              `/merchant/${merchantId}/stampNum/${stampNum}/stampCard/0/singleUseRedeem/status/fail/msg/${e.data[0].detail}`,
            );
            history.go(0);
          }
        }
      }
    },
    [history],
  );

  const handleContactlessCode = useCallback(
    async (contactlessCode: string) => {
      console.log('ContactlessCode: ', contactlessCode);
      if (contactlessCode && contactlessCode.length > 0) {
        try {
          const resStore = await StoreService.getStoreByContactlessCode(
            contactlessCode.split('_')[0],
          );
          if (resStore && resStore.merchant.id) {
            try {
              const resRedeem =
                await StampCardService.creditStampCardContactless(
                  contactlessCode,
                );
              console.log('ResRedeem Contactless: ', resRedeem);
              if (resRedeem && resRedeem.id) {
                // successfully redeemed
                history.replace(
                  `/contactless/${contactlessCode}/merchant/${resStore.merchant.id}/stampCard/${resRedeem.id}/status/success/msg/ok`,
                );
                history.go(0);
              }
            } catch (e: any) {
              // failed to redeem
              if (e && e.data && e.data[0].detail) {
                if (e.data[0].detail === 'Stamp count exceeds store limit') {
                  history.replace(
                    `/contactless/${contactlessCode}/merchant/${resStore.merchant.id}/stampCard/0/status/fail/msg/exceeds_store_limit`,
                  );
                } else {
                  history.replace(
                    `/contactless/${contactlessCode}/merchant/${resStore.merchant.id}/stampCard/0/status/fail/msg/${e.data[0].detail}`,
                  );
                }
                history.go(0);
              }
            }
          }
        } catch (e) {
          console.log('Redeem Contactless Error: ', e);
          history.replace(
            `/contactless/${contactlessCode}/merchant/0/stampCard/0/status/fail/msg/invalid_contactless_code`,
          );
          history.go(0);
        }
      }
    },
    [history],
  );

  const handleCouponCode = useCallback(
    async (couponCode: string) => {
      console.log('CouponCode: ', couponCode);
      if (couponCode && couponCode.length > 0) {
        // check if coupon code has been redeemed
        try {
          const res = await CouponService.get(couponCode);
          console.log('Fetch Coupon: ', res);
          if (res.redeemed) {
            history.replace(
              `/coupon/${couponCode}/merchant/${res.company.id}/status/fail/msg/redeemed_before`,
            );

            history.go(0);
          } else {
            // coupon not redeemed yet
            try {
              const resCoupon = await CouponService.redeem(couponCode);

              if (resCoupon && resCoupon.stampCard.id) {
                history.replace(
                  `/coupon/${couponCode}/merchant/${res.company.id}/status/success/msg/ok`,
                );
                history.go(0);
              }
            } catch (e) {
              console.log('Redeem Coupon Error: ', e);
              history.replace(
                `/coupon/${couponCode}/merchant/${res.company.id}/status/fail/msg/redeemed_failed`,
              );
              history.go(0);
            }
          }
        } catch (e) {
          console.log('Fetch Coupon Error: ', e);
          history.replace(
            `/merchant/0/coupon/${couponCode}/status/fail/msg/not_found`,
          );
          history.go(0);
        }
      }
    },
    [history],
  );

  useEffect(() => {
    if (dl && dl.deeplink) {
      switch (dl.deeplink.feature) {
        case 'merchant':
          if (dl.deeplink.merchantId) {
            history.replace(`/join_merchant/${dl.deeplink.merchantId}`);
            dl.removeDeeplink();
            history.go(0);
          }

          break;
        case 'contactless':
          if (dl.deeplink.contactlessCode) {
            handleContactlessCode(dl.deeplink.contactlessCode);
            // history.replace(`/contactless/${dl.deeplink.contactlessCode}`);
            // history.go(0);
            dl.removeDeeplink();
          }

          break;
        case 'coupon':
          if (dl.deeplink.couponCode) {
            // history.replace(`/coupon/${dl.deeplink.couponCode}`);
            handleCouponCode(dl.deeplink.couponCode);
            dl.removeDeeplink();
          }

          break;
        case 'singleUse':
          if (
            dl.deeplink.singleUseCode &&
            dl.deeplink.merchantId &&
            dl.deeplink.stampNum &&
            dl.deeplink.store
          ) {
            handleSingleUseCode(
              dl.deeplink.singleUseCode,
              dl.deeplink.merchantId,
              dl.deeplink.stampNum,
              dl.deeplink.store,
            );
            dl.removeDeeplink();
            // history.replace(
            //   `/singleuse/${dl.deeplink.singleUseCode}/merchant/${dl.deeplink.merchantId}/stampNum/${dl.deeplink.stampNum}/store/${dl.deeplink.store}`
            // );
            // dl.removeDeeplink();
            // history.go(0);
          }

          break;
        case 'referral':
          history.replace(
            `/referral/merchantCode/${dl.deeplink.merchantCode}/userCode/${dl.deeplink.userCode}`,
          );
          dl.removeDeeplink();
          history.go(0);

          break;
      }
    }
  }, [
    dl,
    history,
    handleSingleUseCode,
    handleCouponCode,
    handleContactlessCode,
  ]);
}
